export default __webpack_public_path__ + "static/media/check-box-image.7417da28.svg";